import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const expertParallelComponent: ComponentDef = {
  id: 'expert-parallel',
  name: 'Expert Parallel',
  description: 'Distribute MoE experts across GPUs and balance load with token dispatch and All2All.',
  category: 'parallelism',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'n_experts', label: 'Experts', type: 'number', default: 8, min: 2, max: 256, step: 1 },
    { name: 'top_k', label: 'Top-k', type: 'number', default: 2, min: 1, max: 8, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const n_experts = Number(params.n_experts);
    const top_k = Number(params.top_k);

    const g = new GraphBuilder();
    g.input('x', [d_model]);

    g.linear('gate', 'x', [d_model, n_experts]);
    g.router('topk', 'gate', [top_k]);
    g.all2all('dispatch', 'topk', [d_model]);
    for (let i = 0; i < n_experts; i++) {
      g.expert(`expert_${i}`, 'dispatch', [d_model], i);
    }
    const experts = Array.from({ length: n_experts }, (_, i) => `expert_${i}`);
    g.concat('combined', experts, [n_experts, d_model]);
    g.all2all('out', 'combined', [d_model]);
    g.output('out', 'out');
    return g.build();
  }
};
